<template>
    <span>
        {{ $t('cart.limitations.addPostalCodeBeforeLink') }}
        <button type="button" class="underline" @click="openModal">
            {{ $t('cart.limitations.addPostalCodeLink') }}
        </button>
        {{ $t('cart.limitations.addPostalCodeAfterLink') }}.
        <template v-if="webshopSettings().pickupIsEnabled">
            {{ ' ' }}{{ $t('cart.limitations.noDeliveryChangePickupBeforeLink') }}
            <DispatchTypeLink :dispatch-type="DispatchTypeOrderBuddy.PICK_UP" class="underline">
                {{ $t('cart.limitations.noDeliveryChangePickupLink') }}
            </DispatchTypeLink>
        </template>
    </span>
</template>

<script lang="ts" setup>
    import { useModalSlot } from 'vue-final-modal'
    import DispatchTypeLink from '~/components/DispatchTypeLink.vue'
    import ModalContentModifyPostalCode from '~/components/Modal/Content/ModalContentModifyPostalCode.vue'
    import { messagesModal } from '~/composables/messagesModal'
    import { webshopSettings } from '~/store/webshopSettings'
    import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
    async function openModal () {
        const modalInstance = await messagesModal({
            default: useModalSlot({
                component: ModalContentModifyPostalCode,
                attrs: {
                    closeModal: () => {
                        modalInstance.close()
                    }
                }
            })
        })
    }
</script>
